<template>
  <div class="quiz__step" id="step-4v1">
    <div class="quiz__tab-item-wrap">
      <div class="quiz__aside">

        <btn-back
            :text="translate.masterBackText"
            @backToStep="backToStep"
        />

        <div class="quiz-checks checks-for-material" v-for="material in materials" :key="material.id+'mq4a'" data-material="{{ material.value }}" v-show="materialParam == material.value" >

          <div v-for="variant in getVariants(material.variants, 'sticking')" :key="variant.id">
            <label class="radio" :class="variant.value == stickingParam ? 'checked' : ''">
              <input type="radio" v-model="stickingParam" name="step-sticking" :value="variant.value" class="param-{{ variant.id }}" />
              <div class="radio__text">{{ variant.name }}</div>
            </label>
          </div>

        </div>


      </div>
      <div class="quiz__content">
        <div v-if="texts && texts['stickingText'+lang]" v-html="texts['stickingText'+lang]">
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BtnBack from "../BtnBack.vue";
export default {
  name: "stickingComponent",
  components: {BtnBack},
  props: ['step', 'translate', 'materials', 'materialParam', 'sticking', 'isLiquid', 'isLoose', 'texts', 'lang', 'dielectricParam', 'longParam'],
  computed:{
    stickingParam:{
       get(){
          return null;// this.sticking;
       },
        set(newVal){

          this.$emit('changeSticking', newVal);


          //Низкая диэл.прониц. (3С, 3В, 3К)
          if(this.dielectricParam == 'low'){

            //Длина ЧЭ 200мм - 2м (3Т, 3С, 3К)
            if(this.longParam <= 20){

              //Налипание продукта возможно 3Т
              if(newVal == '1' || newVal == 1){

                this.$emit('changeNumberType', 3)
                this.$emit('changeLetterType', 'Т')
                this.$emit('changeNextCount', (parseInt(this.step)+2));
              }

              //Нет налипания продукта 3С, 3К
              if(newVal == '0' || newVal == 0){
                this.$emit('changeLetterType', '')
                this.$emit('changeNumberType', 3)
                this.$emit('changeNextCount', 0);
              }

            }

          }


          //Жидкость ( Т, С, В, К, Н)
          if(this.isLiquid && this.dielectricParam == 'hight' && newVal == 1){
            this.$emit('changeNumberType', 4)
            this.$emit('changeLetterType', 'Т')
            this.$emit('changeNextCount', parseInt(this.step)+2);
          }
          if(this.isLiquid && this.dielectricParam == 'hight' && newVal == 0){
            this.$emit('changeNumberType', 4)
            this.$emit('changeLetterType', '')
            this.$emit('changeNextCount', 0);
          }




          if(this.isLoose){

            if(this.dielectricParam == 'wet' && this.longParam < 20 && newVal == 1){
              console.log(1)
              this.$emit('changeNumberType', 3)
              this.$emit('changeLetterType', 'Т')
              this.$emit('changeNextCount', parseInt(this.step)+2);
            }

            if(this.dielectricParam == 'wet' && this.longParam <= 20 && newVal == 0){
              console.log(2)
              this.$emit('changeNumberType', 3)
              this.$emit('changeLetterType', '')
              this.$emit('changeNextCount', 0);
            }

            if(this.dielectricParam == 'wet' && this.longParam >= 20 && newVal == 1){
              console.log(3)
              this.$emit('changeNumberType', 3)
              this.$emit('changeLetterType', 'Д')
              this.$emit('changeNextCount', parseInt(this.step)+2);
            }

            if(this.dielectricParam == 'wet' && this.longParam > 20 && newVal == 0){
              console.log(4)
              this.$emit('changeNumberType', 3)
              this.$emit('changeLetterType', '')
              this.$emit('changeNextCount', 0);
            }


          }





        }
    }
  },

  methods: {
    backToStep() {
      this.$emit('backToStep')
    },
    getVariants(variants, name) {
      return (variants.filter(element => element.step == name));
    },
  },
  watch: {
    step(){



    }
  }
}
</script>

<style scoped>

</style>